import styled from 'styled-components';

const PairContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 10px 20px;
  font-family: 'Pathway Gothic One', sans-serif;
  @media only screen and (min-width: 768px) {
    font-size: 20px;
    marign: 10px 40px;
  }
`;
export default PairContainer;
